import { z } from "zod";

/**
 * Admin suite surface: `POST /api/evals/suites`, `GET /api/evals/suites`.
 *
 * A suite is a named set of playground URLs. Membership is fixed at creation
 * because a batch names the suite, not a copy of its rows, and silently
 * editing a suite would rewrite what a finished batch claims to have covered.
 */

export const EvalSuiteCreateRequestSchema = z
  .object({
    name: z.string().min(1),
    // Empty is refused here rather than producing a batch with nothing in it.
    websiteIds: z.array(z.uuid()).min(1),
  })
  .strict();
export type EvalSuiteCreateRequest = z.infer<
  typeof EvalSuiteCreateRequestSchema
>;

export const EvalSuiteCreateResponseSchema = z.object({ suiteId: z.uuid() });
export type EvalSuiteCreateResponse = z.infer<
  typeof EvalSuiteCreateResponseSchema
>;

export const EvalSuiteSummarySchema = z.object({
  suiteId: z.uuid(),
  name: z.string(),
  websiteCount: z.number().int().min(0),
  createdAt: z.coerce.date(),
});
export type EvalSuiteSummary = z.infer<typeof EvalSuiteSummarySchema>;

export const EvalSuiteListResponseSchema = z.array(EvalSuiteSummarySchema);
export type EvalSuiteListResponse = z.infer<typeof EvalSuiteListResponseSchema>;
